import React, { useCallback, useState } from 'react'
import Header from 'components/Header'
import { Col, Row } from 'react-bootstrap'
import ClientInfoForm from './ClientInfoForm'
import ChangePasswordDialog from './ChangePasswordDialog'
import { useAuth } from 'auth/AuthProvider'

const ProfilePage: React.FC = () => {
  const auth = useAuth()
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  const handleOpenDialog = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    setOpenDialog(true)
  }, [])

  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false)
  }, [])

  return (
    <Row>
      <Col xs={12} className='pt-header'>
        <Header>Профиль пользователя</Header>
        {auth.user && <ClientInfoForm clientInfo={auth.user} onChange={auth.setUser} />}

        <div className='m-3' />
        {!auth.user?.freedom_login && (
          <>
            <a className='my-link' href='/#/' onClick={handleOpenDialog}>
              Изменить пароль
            </a>
            <ChangePasswordDialog show={openDialog} onClose={handleCloseDialog} />
          </>
        )}
      </Col>
    </Row>
  )
}
export default ProfilePage
